import styled from "styled-components";

export const FranchisePubsWrapper = styled.div<{ isApp: number | null }>`
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 100px;
  margin-top: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};
  > .list-wrapper {
    > .header {
      padding: 0 16px;

      font-weight: 800;
      font-size: 20px;
    }

    display: flex;
    gap: 12px;
    flex-direction: column;
    margin-top: 68px;
  }
  background-color: white;
`;

export const RunnerTournamentWrapper = styled.div`
  background-image: url("/image-web/pub/rabbit-banner.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 120px;
  position: relative;
  > .title {
    position: absolute;
    top: 33px;
    left: 20px;
    color: #fff;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .description {
    position: absolute;
    bottom: 33px;
    left: 20px;
    color: #fff;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

export const RunnerWrapper = styled.div`
  margin-top: 108px;
`;

export const FranchisePubsListWrapper = styled.div`
  padding: 16px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  row-gap: 20px;
`;

export const FranchisePubsEmptyWrapper = styled.div<{ color?: string }>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 20px;
  color: ${(p) => p.color || "#000"};
`;
